// Common
import { EVENT_ACTIONS, EVENT_CATEGORIES, TRACKING_PARAMS } from 'constants/tracking.ts'

// Contract flows
export enum ContractFlowTrackingTypes {
  TERMINATE = 'terminate',
  ADD = 'add'
}

export enum ContractFlowStartPoints {
  ADDRESSES = 'address_overview',
  ADDRESS_DETAIL = 'address_detail',
  CONTRACT_OVERVIEW = 'contract_overview',
  FINISH_MOVE = 'finish_move',
  MOVE = 'move'
}

export type EventCategory = (typeof EVENT_CATEGORIES)[keyof typeof EVENT_CATEGORIES] // describes the context the event took place in
export type EventObject = string // (snake_case) noun refers to the component or location the event took place in
export type EventAction = (typeof EVENT_ACTIONS)[keyof typeof EVENT_ACTIONS] // verb that describes what happened
export type TrackingParam = (typeof TRACKING_PARAMS)[keyof typeof TRACKING_PARAMS] // Re-usable tracking params that can be added to any event

export type TrackingEvent = {
  action: EventAction
  category: EventCategory
  object?: EventObject
}

export type EventNameFormat = `${EventCategory}:${EventObject}_${EventAction}` | `${EventCategory}:${EventAction}`
